import { bubEvents } from 'shared/events/bub_events';
import { chirpModal } from 'partials/modals/modal';

window.chirpModal = chirpModal;

function onCloseButtonClick() {
  window.chirpModal.hideModal();

  bubEvents.track('Hear About Us', 'Clicked button', {
    label: 'Dismiss',
  });

  // eslint-disable-next-line no-use-before-define
  turnOffEventListeners();
}

function onSubmit() {
  const radios = $('.heard-about-modal-body-option-radio');
  const checked = radios.filter(':checked');

  bubEvents.track('Hear About Us', 'Clicked button', {
    label: 'Submit',
    value: checked.val(),
    position: radios.index(checked) + 1,
  });
}

function onDocumentClicked(e) {
  const modalEl = document.querySelector('.heard-about-modal');

  if (!modalEl.contains(e.target)) {
    window.chirpModal.hideModal();

    bubEvents.track('Hear About Us', 'Clicked out', {
      label: 'Dismiss',
    });

    // eslint-disable-next-line no-use-before-define
    turnOffEventListeners();
  }
}

function turnOffEventListeners() {
  $('.heard-about-modal-header-close-button').off('click touch', onCloseButtonClick);
  $(document).off('click touch', onDocumentClicked);
}

$(() => {
  if (document.querySelector('.heard-about-modal')) {
    chirpModal.init();
    $('.heard-about-modal-header-close-button').on('click touch', onCloseButtonClick);
    $('form#heard-about-sources-form').submit(onSubmit);
    $('.heard-about-modal-body-option-radio').on('click touch', (e) => {
      $('.heard-about-modal-body-other').prop('disabled', e.currentTarget.value !== 'other');
    });
    $(document).on('click touch', onDocumentClicked);

    $('form#heard-about-sources-form').on('ajax:success', () => {
      window.chirpModal.hideModal();
      turnOffEventListeners();
    });
  }
});
